// @ts-strict-ignore
import React from "react";
import cx from "classnames";
import { Link } from "react-router-dom";
import store from "store";
import storeObservePlugin from "store/plugins/observe";
import classes from "./style.scss";

store.addPlugin(storeObservePlugin);

class BannerWarnings extends React.Component {
	constructor(props) {
		super(props);
		let alreadyVisited = store.get("alreadyVisited");
		
		if (alreadyVisited) {
			alreadyVisited += 1;
		} else {
			alreadyVisited = 1;
		}

		store.set("alreadyVisited", alreadyVisited);
		
		this.state = {
			showCookieWarning: alreadyVisited === 1,
			showInvestmentHealthWarning: false
		};
	}

	componentDidMount() {
		store.observe("investmentHealthWarningAccepted", (val) => {
			if (val === false) this.setState({ showInvestmentHealthWarning: true });
		});
	}

	closeCookieBanner = () => {
		this.setState({
			showCookieWarning: false
		});

		const investmentsViewCount = store.get("investmentsViewCount");
		store.set("investmentsViewCount", investmentsViewCount + 1);
	};

	closeHealthWarning = () => {
		this.setState({
			showInvestmentHealthWarning: false
		});
		store.set("investmentHealthWarningAccepted", true);
	};
	
	render() {
		return (
			<div className={cx(classes.BannerWarnings)}>
				{/* Cookie Warning */}
				
				<div className={cx(classes.banner, { [classes.hide]: !this.state.showCookieWarning })}>
					<div className={cx("contentContainer", "contentContainerRow", classes.inner)}>
						<div className={classes.cookieText}>
							Welcome to DC Byte. This site uses cookies. Read{" "}
							
							<a
								href="https://www.dcbyte.com/privacy/"
								target="_blank"
								rel="noopener noreferrer"
							>
								our policy.
							</a>
						</div>
						
						<div onClick={this.closeCookieBanner} className={classes.cookieCloseButton}>
							{"\ue905"}
						</div>
					</div>
				</div>
				
				{/* Health Warning */}
				
				<div
					className={cx(classes.investmentBackground, {
						[classes.hide]: !this.state.showInvestmentHealthWarning
					})}
				>
					<div className={classes.investmentModal}>
						<div className={classes.investmentTopRow}>
							<div className={classes.logo}>
								<img src="/assets/images/branding/logo-wordmark-colour.png" />
							</div>
						</div>
						
						<div className={classes.investmentText}>
							DC Byte is not authorised by the Financial Conduct Authority in the United Kingdom.
							The information on this Site is provided for your general information only and DC Byte
							makes no reliance on the suitability or otherwise of any investment listings. For full
							details please see our{" "}
							
							<Link
								to="https://www.dcbyte.com/privacy/"
								target="__blank"
								rel="noopener noreferrer"
							>
								Terms of Use.
							</Link>
						</div>
						
						<div className={classes.acceptButton} onClick={this.closeHealthWarning}>
							I ACCEPT THESE TERMS <div className={classes.icon}>{"\ue5c8"}</div>
						</div>
					</div>
				</div>
			</div>
		);
	}
}

export default BannerWarnings;
